import { END_POINT_ADMIN, END_POINT_ADMIN_LOGIN } from "./apiEndPoints";
import ApiManager from "./apiManager";

export class AdminApi {
  async postAdmin(data: any): Promise<any> {
    const res = await ApiManager.post(END_POINT_ADMIN, data);
    if (res) {
      return res;
    }

    return undefined;
  }

  async login(username: string, password: string): Promise<any> {
    const data = {
      username,
      password,
    };
    const res = await ApiManager.post(
      END_POINT_ADMIN_LOGIN,
      data,
      false,
      true,
      false,
    );
    if (res) {
      return res;
    }
    return undefined;
  }
}

export default new AdminApi();
